import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";
import CloudAppAPI from "../../api/CloudAppAPI";
import { newToastEvent } from "../../../utils/ToastUtil";

const useUninstallCloudApp = () => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queryClient = useQueryClient();
  const { tenantID }: any = useParams();

  const uninstallCloudApp = useMutation({
    mutationFn: async (appID: string) => {
      return CloudAppAPI.uninstallCloudApp(workspaceID, appID);
    },
    onSuccess: (response) => {
      const updatedWorkspace = response.data.data.workspace;

      queryClient.setQueryData(["workspace", workspaceID], (data: any) => ({
        ...data,
        workspace: updatedWorkspace,
      }));

      queryClient.invalidateQueries({
        queryKey: ["workspaces", tenantID],
      });

      newToastEvent("success", "Successfully uninstalled app.");
    },
    onError: () => {
      newToastEvent(
        "error",
        "Your dont have permissions to uninstall this app."
      );
    },
  });

  return {
    uninstallCloudApp: uninstallCloudApp.mutate,
    submitting: uninstallCloudApp.isPending,
    error: uninstallCloudApp.isError,
  };
};

export default useUninstallCloudApp;
